import { PaymentStatus } from '@typings/graphql'

export enum ColumnStatusCouponStatus {
  Active = 'ACTIVE',
  Used = 'USED'
}

export const PIE_COLORS = [
  '#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F',
  '#EDC948', '#B07AA1', '#FF9DA7', '#9C755F', '#BAB0AC',
  '#86B7F3', '#FFB74D', '#FA8072', '#66C2A5', '#A6D854',
  '#FFD92F', '#C2A5CF', '#FC8D62', '#8DA0CB', '#E78AC3'
]

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus | ColumnStatusCouponStatus, string> = {
  [PaymentStatus.Success]: 'success',
  [PaymentStatus.Failed]: 'error',
  [PaymentStatus.Pending]: 'warning',
  [ColumnStatusCouponStatus.Active]: 'warning',
  [ColumnStatusCouponStatus.Used]: 'success'
}
